import React from 'react';

const FilterIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4375_377)">
        <path d="M8.025 1.96837C7.81411 1.51998 7.47998 1.14086 7.06163 0.875311C6.64329 0.609762 6.15801 0.46875 5.6625 0.46875C5.16699 0.46875 4.68171 0.609762 4.26337 0.875311C3.84502 1.14086 3.51089 1.51998 3.3 1.96837H0V4.21837H3.29625C3.50714 4.66676 3.84127 5.04588 4.25962 5.31143C4.67796 5.57698 5.16324 5.71799 5.65875 5.71799C6.15426 5.71799 6.63954 5.57698 7.05788 5.31143C7.47623 5.04588 7.81036 4.66676 8.02125 4.21837H18V1.96837H8.025Z" fill="#3D3D3D"/>
        <path d="M12.3412 6.375C11.8458 6.37588 11.3607 6.51729 10.9424 6.7828C10.5241 7.04831 10.1897 7.42704 9.978 7.875H0V10.125H9.975C10.1859 10.5734 10.52 10.9525 10.9384 11.2181C11.3567 11.4836 11.842 11.6246 12.3375 11.6246C12.833 11.6246 13.3183 11.4836 13.7366 11.2181C14.155 10.9525 14.4891 10.5734 14.7 10.125H18V7.875H14.7037C14.4921 7.42715 14.1578 7.04851 13.7396 6.783C13.3215 6.5175 12.8366 6.37602 12.3412 6.375Z" fill="#3D3D3D"/>
        <path d="M5.65875 12.2812C5.16342 12.2823 4.67853 12.4237 4.26036 12.6893C3.84219 12.9548 3.50789 13.3334 3.29625 13.7813H0V16.0313H3.29625C3.50714 16.4796 3.84127 16.8588 4.25962 17.1243C4.67796 17.3899 5.16324 17.5309 5.65875 17.5309C6.15426 17.5309 6.63954 17.3899 7.05788 17.1243C7.47623 16.8588 7.81036 16.4796 8.02125 16.0313H18V13.7813H8.025C7.81309 13.3328 7.47821 12.9538 7.05931 12.6882C6.64041 12.4227 6.15472 12.2816 5.65875 12.2812Z" fill="#3D3D3D"/>
      </g>
      <defs>
        <clipPath id="clip0_4375_377">
        <rect width="18" height="18" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  );
};

export default FilterIcon;
